@if (!isNative) {
    <div class="wrapper" [class.hide]="hide()">
        <ion-button shape="round" fill="clear" color="medium" size="small" (click)="onClose()">
            <i slot="icon-only" class="material-symbols-outlined">close</i>
        </ion-button>
        <img src="/assets/icons/favicon.png" alt="Drive & Tow, LLC">
        <p>Get the app for the best experience!</p>
        <ion-button [href]="url">Install</ion-button>
    </div>
}
